module.exports = __webpack_public_path__ + "assets/roboto-v20-latin-regular.eot?4be1a572fca40bcb2202504cb17aed91";